const fonts = `system-ui, -apple-system, BlinkMacSystemFont,
'Segoe UI', 'Roboto', 'Helvetica Neue', Helvetica, sans-serif`


const theme = {
    colors: {
      dark: '#1e1e1e',
      snow: '#eaeaea',
      muted: '#666',
      red: '#e55934',
      orange: '#fa7921',
      yellow: '#fde74c',
      green: '#9bc53d',
      blue: '#5a85ea',
  
      chn: '#d63336',
      deu: '#2799f4',
      esp: '#2ef1d6',
      fra: '#8100fb',
      gbr: '#1417f8',
      irn: '#e6d734',
      itl: '#7dea32',
      kor: '#e55934',
      usa: '#ff00f2'
    },
    fonts: {
      sans: `'Gotham Rounded SSm A', 'Gotham Rounded SSm B', ${fonts}`,
      serif: `Sentinel, ${fonts}`,
      system: fonts
    }
  }
  
  export default theme